import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installNetworkMonitor } from './utils/networkStatus';
import { installServerClock } from './utils/serverClock';
import reportWebVitals from './reportWebVitals';

installNetworkMonitor();
installServerClock();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        const announceUpdate = () => window.dispatchEvent(new CustomEvent('pwa:update-available'));
        if (registration.waiting && navigator.serviceWorker.controller) announceUpdate();
        registration.addEventListener('updatefound', () => {
          const worker = registration.installing;
          worker?.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) announceUpdate();
          });
        });
        registration.update().catch(() => {});
      })
      .catch((err) => {
        console.warn('ServiceWorker registration failed:', err);
      });
  });
} else if ('serviceWorker' in navigator) {
  // A service worker must never cache CRA hot-update/bundle files on localhost.
  // Remove registrations and app-shell caches left by an earlier development run.
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => {});
    if ('caches' in window) {
      caches.keys()
        .then((names) => Promise.all(names.filter((name) => name.startsWith('alef-shell-')).map((name) => caches.delete(name))))
        .catch(() => {});
    }
  });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
